/* tslint:disable */
/* eslint-disable */
/**
 * Cerebral Machines API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CanonicalTermCreate } from '../models';
// @ts-ignore
import type { CanonicalTermUpdate } from '../models';
// @ts-ignore
import type { ValidationErrorModel } from '../models';
/**
 * CanonicalTermApi - axios parameter creator
 */
export const CanonicalTermApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new canonical term
         * @param {CanonicalTermCreate} canonicalTermCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canonicalTermCreatePost: async (canonicalTermCreate: CanonicalTermCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'canonicalTermCreate' is not null or undefined
            assertParamExists('canonicalTermCreatePost', 'canonicalTermCreate', canonicalTermCreate)
            const localVarPath = `/api/canonical-terms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(canonicalTermCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a canonical term by ID
         * @param {string} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canonicalTermDeleteTermIdDelete: async (termId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('canonicalTermDeleteTermIdDelete', 'termId', termId)
            const localVarPath = `/api/canonical-terms/{term_id}`
                .replace(`{${"term_id"}}`, encodeURIComponent(String(termId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a canonical term by ID
         * @param {string} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canonicalTermGetTermIdGet: async (termId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('canonicalTermGetTermIdGet', 'termId', termId)
            const localVarPath = `/api/canonical-terms/{term_id}`
                .replace(`{${"term_id"}}`, encodeURIComponent(String(termId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all canonical terms
         * @param {string | null} [search] 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canonicalTermListGet: async (search?: string | null, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/canonical-terms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a canonical term by ID
         * @param {string} termId 
         * @param {CanonicalTermUpdate} canonicalTermUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canonicalTermUpdateTermIdPut: async (termId: string, canonicalTermUpdate: CanonicalTermUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('canonicalTermUpdateTermIdPut', 'termId', termId)
            // verify required parameter 'canonicalTermUpdate' is not null or undefined
            assertParamExists('canonicalTermUpdateTermIdPut', 'canonicalTermUpdate', canonicalTermUpdate)
            const localVarPath = `/api/canonical-terms/{term_id}`
                .replace(`{${"term_id"}}`, encodeURIComponent(String(termId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(canonicalTermUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CanonicalTermApi - functional programming interface
 */
export const CanonicalTermApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CanonicalTermApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new canonical term
         * @param {CanonicalTermCreate} canonicalTermCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async canonicalTermCreatePost(canonicalTermCreate: CanonicalTermCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CanonicalTermCreate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.canonicalTermCreatePost(canonicalTermCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CanonicalTermApi.canonicalTermCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a canonical term by ID
         * @param {string} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async canonicalTermDeleteTermIdDelete(termId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.canonicalTermDeleteTermIdDelete(termId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CanonicalTermApi.canonicalTermDeleteTermIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a canonical term by ID
         * @param {string} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async canonicalTermGetTermIdGet(termId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.canonicalTermGetTermIdGet(termId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CanonicalTermApi.canonicalTermGetTermIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all canonical terms
         * @param {string | null} [search] 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async canonicalTermListGet(search?: string | null, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.canonicalTermListGet(search, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CanonicalTermApi.canonicalTermListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a canonical term by ID
         * @param {string} termId 
         * @param {CanonicalTermUpdate} canonicalTermUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async canonicalTermUpdateTermIdPut(termId: string, canonicalTermUpdate: CanonicalTermUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.canonicalTermUpdateTermIdPut(termId, canonicalTermUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CanonicalTermApi.canonicalTermUpdateTermIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CanonicalTermApi - factory interface
 */
export const CanonicalTermApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CanonicalTermApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new canonical term
         * @param {CanonicalTermApiCanonicalTermCreatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canonicalTermCreatePost(requestParameters: CanonicalTermApiCanonicalTermCreatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CanonicalTermCreate> {
            return localVarFp.canonicalTermCreatePost(requestParameters.canonicalTermCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a canonical term by ID
         * @param {CanonicalTermApiCanonicalTermDeleteTermIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canonicalTermDeleteTermIdDelete(requestParameters: CanonicalTermApiCanonicalTermDeleteTermIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.canonicalTermDeleteTermIdDelete(requestParameters.termId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a canonical term by ID
         * @param {CanonicalTermApiCanonicalTermGetTermIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canonicalTermGetTermIdGet(requestParameters: CanonicalTermApiCanonicalTermGetTermIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.canonicalTermGetTermIdGet(requestParameters.termId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all canonical terms
         * @param {CanonicalTermApiCanonicalTermListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canonicalTermListGet(requestParameters: CanonicalTermApiCanonicalTermListGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.canonicalTermListGet(requestParameters.search, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a canonical term by ID
         * @param {CanonicalTermApiCanonicalTermUpdateTermIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canonicalTermUpdateTermIdPut(requestParameters: CanonicalTermApiCanonicalTermUpdateTermIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.canonicalTermUpdateTermIdPut(requestParameters.termId, requestParameters.canonicalTermUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for canonicalTermCreatePost operation in CanonicalTermApi.
 */
export interface CanonicalTermApiCanonicalTermCreatePostRequest {
    readonly canonicalTermCreate: CanonicalTermCreate
}

/**
 * Request parameters for canonicalTermDeleteTermIdDelete operation in CanonicalTermApi.
 */
export interface CanonicalTermApiCanonicalTermDeleteTermIdDeleteRequest {
    readonly termId: string
}

/**
 * Request parameters for canonicalTermGetTermIdGet operation in CanonicalTermApi.
 */
export interface CanonicalTermApiCanonicalTermGetTermIdGetRequest {
    readonly termId: string
}

/**
 * Request parameters for canonicalTermListGet operation in CanonicalTermApi.
 */
export interface CanonicalTermApiCanonicalTermListGetRequest {
    readonly search?: string | null

    readonly limit?: number | null

    readonly offset?: number | null
}

/**
 * Request parameters for canonicalTermUpdateTermIdPut operation in CanonicalTermApi.
 */
export interface CanonicalTermApiCanonicalTermUpdateTermIdPutRequest {
    readonly termId: string

    readonly canonicalTermUpdate: CanonicalTermUpdate
}

/**
 * CanonicalTermApi - object-oriented interface
 */
export class CanonicalTermApi extends BaseAPI {
    /**
     * 
     * @summary Create a new canonical term
     * @param {CanonicalTermApiCanonicalTermCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public canonicalTermCreatePost(requestParameters: CanonicalTermApiCanonicalTermCreatePostRequest, options?: RawAxiosRequestConfig) {
        return CanonicalTermApiFp(this.configuration).canonicalTermCreatePost(requestParameters.canonicalTermCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a canonical term by ID
     * @param {CanonicalTermApiCanonicalTermDeleteTermIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public canonicalTermDeleteTermIdDelete(requestParameters: CanonicalTermApiCanonicalTermDeleteTermIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return CanonicalTermApiFp(this.configuration).canonicalTermDeleteTermIdDelete(requestParameters.termId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a canonical term by ID
     * @param {CanonicalTermApiCanonicalTermGetTermIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public canonicalTermGetTermIdGet(requestParameters: CanonicalTermApiCanonicalTermGetTermIdGetRequest, options?: RawAxiosRequestConfig) {
        return CanonicalTermApiFp(this.configuration).canonicalTermGetTermIdGet(requestParameters.termId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all canonical terms
     * @param {CanonicalTermApiCanonicalTermListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public canonicalTermListGet(requestParameters: CanonicalTermApiCanonicalTermListGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CanonicalTermApiFp(this.configuration).canonicalTermListGet(requestParameters.search, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a canonical term by ID
     * @param {CanonicalTermApiCanonicalTermUpdateTermIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public canonicalTermUpdateTermIdPut(requestParameters: CanonicalTermApiCanonicalTermUpdateTermIdPutRequest, options?: RawAxiosRequestConfig) {
        return CanonicalTermApiFp(this.configuration).canonicalTermUpdateTermIdPut(requestParameters.termId, requestParameters.canonicalTermUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

